import { CreateAttachmentHandlerParams } from '../types/CreateAttachmentHandler';
import { logUsage } from 'owa-analytics';
import { AttachmentFileList } from 'owa-attachment-file-types';
import { getExtensionFromFileName } from 'owa-file';

function getExtensionsFromFiles(files: AttachmentFileList): string[] {
    let exts = [];
    let i = 0;
    while (files[i]) {
        exts = exts.concat(getExtensionFromFileName(files[i].name));
        i++;
    }
    return exts;
}

export function logAttachOrShareDatapoint(
    params: CreateAttachmentHandlerParams,
    suggestedAttachmentTraceId?: string
) {
    const { files, shouldShare, isInline, dataProviderType } = params;

    let fileSizes: number[] = [];
    let i = 0;
    while (files[i]) {
        fileSizes = fileSizes.concat(files[i].size);
        i++;
    }

    const exts = getExtensionsFromFiles(files);

    logUsage(
        'AFPAttachOrShare',
        [
            shouldShare,
            isInline,
            fileSizes.join(','),
            files.length,
            dataProviderType,
            exts.join(','),
            false,
            suggestedAttachmentTraceId,
        ],
        { isCore: true, excludeFromKusto: true }
    );
}
